import { useState, useEffect } from 'react';

import { WT_EXPERIMENTS_INITIALIZED } from './constants';

import { getIsInitialised } from '.';

export const useExperiments = (): {
  isReady: boolean;
} => {
  const initialState = getIsInitialised();
  const [isReady, setIsReady] = useState(initialState);

  useEffect(() => {
    if (isReady) {
      return;
    }

    const handleIsReady = () => {
      setIsReady(true);
    };

    window.addEventListener(WT_EXPERIMENTS_INITIALIZED, handleIsReady);

    return () =>
      window.removeEventListener(WT_EXPERIMENTS_INITIALIZED, handleIsReady);
  }, [isReady]);

  return {
    isReady,
  };
};

interface Experiment {
  isControl: () => boolean;
}

/**
 * Returns `true` if Amplitude experiment data is ready and the given experiment is not in the control group. Otherwise, returns `false`.
 */
export const useIsExperimentActive = (experiment: Experiment): boolean =>
  useExperiments().isReady && !experiment.isControl();
